import React from 'react';
import { StyleSheet, View, Text } from './components/base_components';
import ProgressSpinner from './components/progress_spinner';
import DialogScreen from './components/dialog_screen';

import UserStore from './stores/user_store';

const styles = StyleSheet.create({
  homeScreen: {
    flex: 1,
    alignSelf: 'stretch',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
  },
  body: {
    flex: 1,
    alignSelf: 'stretch',
  },
  title: {
    color: '#333',
    fontSize: '2rem',
    fontWeight: '600',
  },
});

export default function HomeScreen() {
  const user = UserStore.useUser();

  let content: any = null;
  if (!user) {
    content = <ProgressSpinner />;
  } else {
    content = (
      <View style={styles.homeScreen}>
        <View style={styles.body}>
          <DialogScreen>
            <Text style={styles.title}>Welcome to Admin</Text>
          </DialogScreen>
        </View>
      </View>
    );
  }

  return content;
}
